import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ClipboardCopyComponent } from './clipboard-copy.component';

@NgModule({
	declarations: [ClipboardCopyComponent],
	imports: [CommonModule, TooltipModule],
	exports: [ClipboardCopyComponent],
})
export class ClipboardCopyModule {}
